import { jsonp, ajax } from '@ifeng-fe/ui_base';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;

/* eslint-enable no-undef */

if (typeof window !== 'undefined' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/api';
}

const createJsonpCallbackName = (str, num) => {
    const md5 = require('md5');

    num = num ? num : 0;
    const jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    if (typeof window !== 'undefined' && window[jsonpCallbackName]) {
        num++;
        createJsonpCallbackName(str, num);
    } else {
        return jsonpCallbackName;
    }
};

/* 公共 */

// 获取文章评论数
const getCommentCount = async url => {
    return await jsonp('//comment.ifeng.com/get.php', {
        data: {
            job: 4,
            format: 'js',
            callback: 'getAllComment1',
            docurl: url.join('|'),
        },
        jsonCallback: 'getAllComment1',
        cache: false,
    });
};

// 点击更多，获取信息流
// const getColumnInfo = async (id, time, size, columnId) => {
//     return await ajax(`/c/api/getColumnInfo/${id}/${time}/${size}/${columnId}`);
// };

// 点击更多，获取信息流
// const getColumnInfo2 = async (id, time, size, columnId) => {
//     return await jsonp(`${apiBaseUrl}/getColumnInfo2/${id}/${time}/${size}/${columnId}/getColumnInfoCallback`, {
//         jsonpCallback: 'getColumnInfoCallback',
//     });
// };

// 点击更多，获取信息流
const getColumnInfo2_v2 = async (columnId, page, pageSize) => {
    return await jsonp(`${apiBaseUrl}/getColumnInfo2_v2/${columnId}/${page}/${pageSize}/getColumnInfoCallback`, {
        jsonpCallback: 'getColumnInfoCallback',
    });
};

// 点击更多，获取科技频道信息流
const getTechInfo = async (id, time, size, columnId) => {
    return await jsonp(`${apiBaseUrl}/getTechInfo/${id}/${time}/${size}/${columnId}/getTechInfoCallback`, {
        jsonpCallback: 'getTechInfoCallback',
    });
};

// 获取公益频道信息流
// const getGongyiData = async (id, time, size, columnId) => {
//     return await jsonp(`${apiBaseUrl}/getGongyiData/${id}/${time}/${size}/${columnId}/getGongyiDataCallback`, {
//         jsonpCallback: 'getGongyiDataCallback',
//     });
// };

// 获取公益频道信息流 v2
const getGongyiData_v2 = async (id, page, pageSize) => {
    return await jsonp(`${apiBaseUrl}/getGongyiData_v2/${id}/${page}/${pageSize}/getGongyiData_v2Callback`, {
        jsonpCallback: 'getGongyiData_v2Callback',
    });
};

/**
 * 获取页面动态碎片数据
 * @param {Array} recommendDataIds 推荐位数据IDs
 * @param {String} searchPath searchPath
 * @param {Number} page 当前页数
 * @param {Number} pageSize 每页请求条数
 * @returns {Object} {dynamicList, pageInfo}
 */
const getDynamicData = async ({ recommendDataIds = [], searchPath = 0, page = 1, pageSize = 9 }) => {
    const recommendIds = recommendDataIds.join(',');

    const data = await jsonp(
        `${apiBaseUrl}/getDynamicData/${searchPath}/${recommendIds}/${page}/${pageSize}/getDynamicData`,
        {
            jsonpCallback: 'getDynamicData',
        },
    );

    return data.data;
};

/**
 * 获取页面动态碎片数据
 * @param {Array} recommendDataIds 推荐位数据IDs
 * @param {String} searchPath searchPath
 * @param {Number} page 当前页数
 * @param {Number} pageSize 每页请求条数
 * @returns {Object} {dynamicList, pageInfo}
 */
const getDynamicData_v2 = async ({ recommendIds = [], id = 0, page = 1, pageSize = 9 }) => {
    recommendIds = recommendIds.join(',');

    return await jsonp(`${apiBaseUrl}/getDynamicData_v2/${recommendIds}/${id}/${page}/${pageSize}/getDynamicData`, {
        jsonpCallback: 'getDynamicData',
    });
};

// 点击更多，获取信息流
const getYoungInfo = async (columnId, page, pageSize) => {
    return await jsonp(`${apiBaseUrl}/getYoungInfo_v2/${columnId}/${page}/${pageSize}/getYoungInfoCallback`, {
        jsonpCallback: 'getYoungInfoCallback',
    });
};

// 青年频道 获取文章推荐数

const getVoteNum = async url => {
    // const { schemaCheck } = await import('./validate');

    let apiUrl = '//survey.news.ifeng.com/api/getaccumulatorweight?';

    // 接口拼接
    if (url.length > 0) {
        url.forEach(item => {
            apiUrl += `key[]=${item}ding&`;
        });
    }

    let data = await jsonp(apiUrl, {
        data: {
            format: 'js',
            serviceid: 2,
        },
        jsonCallback: 'getaccumulator',
        cache: false,
    });
    // const requestUrl = `//survey.news.ifeng.com/api/getaccumulatorweight?format=js&key=${vid}&callback=getaccumulator`;

    // data = schemaCheck(data.data, 'voteNumSchema', requestUrl);
    data = data.data;

    return data ? data : null;
};

// 获取视频播放数
const getVideoComment = async vid => {
    // const { schemaCheck } = await import('./validate');

    let apiUrl = '//survey.news.ifeng.com/api/getaccumulatorweight?';

    // 接口拼接
    if (vid.length > 0) {
        vid.forEach(item => {
            apiUrl += `key[]=${item}&`;
        });
    }

    let data = await jsonp(apiUrl, {
        data: {
            format: 'js',
            serviceid: 1,
        },
        jsonCallback: 'getVideoComment1',
        cache: false,
    });
    // const requestUrl = `//survey.news.ifeng.com/api/getaccumulatorweight?format=js&key=${vid}&callback=getaccumulator`;

    // data = schemaCheck(data.data, 'voteNumSchema', requestUrl);
    data = data.data;

    return data ? data : null;
};
// 财经研究院 专栏列表页面右侧委员信息

const getWyList = async text => {
    return await jsonp('//yjy.finance.ifeng.com/index/getWyList', {
        cache: true,
        jsonpCallback: 'success_jsonpCallback_search',
        data: { con: text },
    });
};

// 财经研究院 专栏列表页面右侧 查询委员信息
const searchWyList = async text => {
    return await jsonp('//yjy.finance.ifeng.com/index/search', {
        cache: true,
        jsonpCallback: 'success_jsonpCallback_searchwy',
        data: { con: text },
    });
};

// 视频信息流
const getVideoStream = async (page, pageSize, columnId, source) => {
    return await jsonp(`${apiBaseUrl}/getVideoStream/${page}/${pageSize}/${columnId}/${source}/getVideoStream`, {
        jsonpCallback: 'getVideoStream',
        cache: false,
    });
};

export {
    getCommentCount,
    // getColumnInfo2,
    getColumnInfo2_v2,
    getDynamicData,
    getDynamicData_v2,
    getTechInfo,
    // getGongyiData,
    getGongyiData_v2,
    getYoungInfo,
    getVoteNum,
    getVideoComment,
    getWyList,
    searchWyList,
    getVideoStream,
};
